module.exports = __webpack_public_path__ + "img/map-pin.d23a9916.svg";